module.exports = __webpack_public_path__ + "media/img/private-venue/chart-d690b980c232320e1649f8c3f12b23a7.svg";